import { SelectOption } from './types';

export const Option = ({ value, label, ...props }: SelectOption) => {
  return (
    <option value={value} {...props}>
      {label}
    </option>
  );
};
